import { render, staticRenderFns } from "./prescriptionWindow.vue?vue&type=template&id=51a05336&scoped=true"
import script from "./prescriptionWindow.vue?vue&type=script&lang=js"
export * from "./prescriptionWindow.vue?vue&type=script&lang=js"
import style0 from "./prescriptionWindow.vue?vue&type=style&index=0&id=51a05336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a05336",
  null
  
)

export default component.exports